export function collectionDraft({totalCents, paidCents, receivedCents}) {
  if (![totalCents,paidCents,receivedCents].every(n=>Number.isSafeInteger(n)&&n>=0)) throw new Error('Introduce un importe válido.');
  const balanceCents=Math.max(0,totalCents-paidCents);
  if(receivedCents>balanceCents) throw new Error('El importe supera el saldo pendiente.');
  const nextPaidCents=paidCents+receivedCents;
  return {nextPaidCents,balanceCents:Math.max(0,totalCents-nextPaidCents),paymentStatus:nextPaidCents>=totalCents&&totalCents>0?'paid':nextPaidCents>0?'partial':'pending'};
}
export function collectionInputCents(value) {
  const raw=String(value??'').trim();
  if(!raw) return 0;
  if(!/^\d+(?:[.,]\d{0,2})?$/.test(raw)) return NaN;
  return Math.round(Number(raw.replace(',','.'))*100);
}

export function collectionSaveDecision({currentPaidCents,basePaidCents,targetPaidCents,totalCents}) {
 if(![currentPaidCents,basePaidCents,targetPaidCents,totalCents].every(n=>Number.isSafeInteger(n)&&n>=0)) throw new Error('Importes no válidos.');
 if(currentPaidCents===targetPaidCents) return {changed:false};
 if(currentPaidCents!==basePaidCents) throw new Error('El cobro cambió mientras editabas. Cierra y vuelve a abrir la reserva.');
 const receivedCents=targetPaidCents-basePaidCents;
 if(receivedCents<=0) throw new Error('Un abono registrado no se puede reducir desde este formulario.');
 return {...collectionDraft({totalCents,paidCents:basePaidCents,receivedCents}),changed:true};
}
